import FormError from '@/components/Form/Error'
import { VStack } from '@/components/Layout/Stacks'
import { Skeleton } from '@/components/ui/skeleton'
import { useKycToken } from '@/lib/queries/kycToken'
import { EXTERNAL_LINKS } from '@shared/constants/links'
import { useTranslations } from 'next-intl'

export function KYCStep() {
  const t = useTranslations('account.kyc.dialog')
  const { data, error, isLoading } = useKycToken()

  if (isLoading) {
    return (
      // Trying to match the cards in the iframe
      <VStack className="gap-4 mt-6">
        <Skeleton className="h-32 pb-6 rounded-2xl" />
        <Skeleton className="h-32 pb-6 rounded-2xl" />
      </VStack>
    )
  }

  if (error || !data?.data?.token) {
    return (
      <div className="p-6 h-5 flex items-center  ">
        <FormError error={error ?? { message: 'No token found' }} />
      </div>
    )
  }

  return (
    <>
      <div className="h-[60vh] -mx-6 -mb-6 rounded-b-lg overflow-hidden">
        <iframe
          src={EXTERNAL_LINKS.getCambixKycUrl(data?.data?.token)}
          className="w-full h-full"
        />
      </div>
    </>
  )
}
